if (!customElements.get('product-feature-icons')) {
  customElements.define(
    'product-feature-icons',
    class ProductFeatureIcons extends HTMLElement {
      connectedCallback() {
        this.list = this.querySelector('.product-feature-icons__list');
        if (!this.list) return;

        this.isDragging = false;
        this.dragStartX = 0;
        this.dragScrollLeft = 0;

        this.abortController = new AbortController();
        const { signal } = this.abortController;

        this.updateScrollState();
        window.addEventListener('resize', this.updateScrollState.bind(this), { signal });

        if (window.matchMedia('(pointer: fine)').matches) {
          this.initDragScroll(signal);
        }

        this.initWheelScroll(signal);
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      updateScrollState() {
        if (!this.list) return;

        const isScrollable = this.list.scrollWidth > this.list.clientWidth + 1;
        this.list.classList.toggle('is-drag-scroll', isScrollable);
      }

      initDragScroll(signal) {
        this.list.addEventListener('pointerdown', this.onPointerDown.bind(this), { signal });
        this.list.addEventListener('pointermove', this.onPointerMove.bind(this), { signal });
        this.list.addEventListener('pointerup', this.onPointerUp.bind(this), { signal });
        this.list.addEventListener('pointercancel', this.onPointerUp.bind(this), { signal });
      }

      onPointerDown(event) {
        if (event.button !== 0 || this.list.scrollWidth <= this.list.clientWidth) return;

        event.preventDefault();

        this.isDragging = true;
        this.dragStartX = event.clientX;
        this.dragScrollLeft = this.list.scrollLeft;
        this.list.classList.add('is-dragging');
        this.list.setPointerCapture(event.pointerId);
      }

      onPointerMove(event) {
        if (!this.isDragging) return;

        event.preventDefault();
        this.list.scrollLeft = this.dragScrollLeft - (event.clientX - this.dragStartX);
      }

      onPointerUp(event) {
        if (!this.isDragging) return;

        this.isDragging = false;
        this.list.classList.remove('is-dragging');

        if (this.list.hasPointerCapture?.(event.pointerId)) {
          this.list.releasePointerCapture(event.pointerId);
        }
      }

      initWheelScroll(signal) {
        this.list.addEventListener(
          'wheel',
          (event) => {
            if (this.list.scrollWidth <= this.list.clientWidth) return;

            const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
            if (delta === 0) return;

            event.preventDefault();
            this.list.scrollLeft += delta;
          },
          { signal, passive: false }
        );
      }
    }
  );
}
